import { Navigate, Outlet, useLocation } from "react-router-dom";
import BoardLoading from "@/components/BoardLoading";
import { useAuth } from "@/auth/AuthContext";

export default function ProtectedRoute() {
  const { loading, user } = useAuth();
  const location = useLocation();
  if (loading) return <BoardLoading label="Checking secure session" />;
  if (!user)
    return <Navigate replace state={{ from: location.pathname }} to="/login" />;
  if (
    user.platform_role === "platform_owner" &&
    !location.pathname.startsWith("/platform")
  )
    return <Navigate replace to="/platform/companies" />;
  if (
    user.platform_role !== "platform_owner" &&
    location.pathname.startsWith("/platform")
  )
    return <Navigate replace to="/master-project-board" />;
  if (user.must_change_password && location.pathname !== "/change-password")
    return <Navigate replace to="/change-password" />;
  return <Outlet />;
}
